import type { TLMSAdminRole, TLMSRoleOption } from './types'

export const ROLE_OPTIONS: TLMSRoleOption[] = [
  {
    label: 'super-admin',
    value: 'super-admin',
  },
  {
    label: 'admin-entitas',
    value: 'admin-entitas',
  },
  {
    label: 'admin-pusat',
    value: 'admin-pusat',
  },
  {
    label: 'admin-lptk',
    value: 'admin-lptk',
  },
  {
    label: 'instruktur-webinar-pgp',
    value: 'instruktur-webinar-pgp',
  },
  {
    label: 'otorisasi-sertifikat',
    value: 'otorisasi-sertifikat',
  },
]

const LIST_ROLE_OPTIONS_RULES: Record<
  TLMSAdminRole,
  Record<'delete' | 'update', TLMSAdminRole[]>
> = {
  'super-admin': {
    update: [
      'admin-pusat',
      'admin-entitas',
      'admin-lptk',
      'instruktur-webinar-pgp',
      'otorisasi-sertifikat',
    ],
    delete: [
      'admin-pusat',
      'admin-entitas',
      'admin-lptk',
      'instruktur-webinar-pgp',
      'otorisasi-sertifikat',
    ],
  },
  'admin-pusat': {
    update: [],
    delete: ['admin-entitas', 'admin-lptk', 'instruktur-webinar-pgp'],
  },
  'admin-entitas': {
    update: [],
    delete: [],
  },
  'admin-lptk': {
    update: [],
    delete: [],
  },
  'instruktur-webinar-pgp': {
    update: [],
    delete: [],
  },
  'otorisasi-sertifikat': {
    update: [],
    delete: [],
  },
}

const MODAL_ROLE_OPTIONS_RULES: Record<
  TLMSAdminRole,
  Record<'create' | 'update' | 'delete', TLMSAdminRole[]>
> = {
  'super-admin': {
    create: [
      'admin-pusat',
      'admin-entitas',
      'super-admin',
      'admin-lptk',
      'instruktur-webinar-pgp',
      'otorisasi-sertifikat',
    ],
    update: [
      'admin-pusat',
      'admin-entitas',
      'super-admin',
      'admin-lptk',
      'instruktur-webinar-pgp',
      'otorisasi-sertifikat',
    ],
    delete: [
      'admin-pusat',
      'admin-entitas',
      'super-admin',
      'admin-lptk',
      'instruktur-webinar-pgp',
      'otorisasi-sertifikat',
    ],
  },
  'admin-pusat': {
    create: ['admin-entitas', 'admin-lptk', 'instruktur-webinar-pgp'],
    update: ['admin-entitas', 'admin-lptk', 'instruktur-webinar-pgp'],
    delete: ['admin-entitas', 'admin-lptk', 'instruktur-webinar-pgp'],
  },
  'admin-entitas': {
    create: ['instruktur-webinar-pgp'],
    update: ['instruktur-webinar-pgp'],
    delete: ['instruktur-webinar-pgp'],
  },
  'admin-lptk': {
    create: [],
    delete: [],
    update: [],
  },
  'instruktur-webinar-pgp': {
    create: [],
    update: [],
    delete: [],
  },
  'otorisasi-sertifikat': {
    create: [],
    update: [],
    delete: [],
  },
}

export const canManageAdminRole = ({
  actorRole,
  action,
  targetRole,
}: {
  actorRole?: TLMSAdminRole | ''
  action: 'update' | 'delete'
  targetRole: TLMSAdminRole
}) => {
  if (!actorRole) return false
  return LIST_ROLE_OPTIONS_RULES[actorRole][action].includes(targetRole)
}

export const getAvailableRoleOptionsByAction = ({
  actorRole,
  action,
  roleOptions,
}: {
  actorRole?: TLMSAdminRole | ''
  action: 'create' | 'update' | 'delete'
  roleOptions: TLMSRoleOption[]
}) => {
  if (!actorRole) return []
  const availableRoles = MODAL_ROLE_OPTIONS_RULES[actorRole][action]
  return roleOptions.filter((role) => availableRoles.includes(role.value))
}
